import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/style.css'
import '@/assets/css/sty.css'

// 引入 Bootstrap 基础样式，恢复 .container / .navbar 等布局
import 'bootstrap/dist/css/bootstrap.min.css'
// 引入 Bootstrap JavaScript 依赖
import $ from 'jquery'
import Popper from 'popper.js'
import 'bootstrap/dist/js/bootstrap.min.js'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

